<template>
    <div class="container-fluid p-0">
        <!-- Desktop View (horizontal buttons) -->
        <div class="d-none d-md-flex align-items-center gap-2 p-3 bg-light border-bottom">
            <button @click="handleClicked('new')" class="btn btn-primary">
                <i class="bi bi-plus-circle me-1"></i> New
            </button>
            <button @click="handleClicked('save')" class="btn btn-outline-secondary">
                <i class="bi bi-floppy-fill me-1"></i> Save
            </button>
            <button @click="handleClicked('load')" class="btn btn-outline-secondary">
                <i class="bi bi-download me-1"></i> Load
            </button>
            <button @click="handleClicked('print')" class="btn btn-outline-secondary">
                <i class="bi bi-printer me-1"></i> Print
            </button>
            <button @click="handleClicked('prev')" class="btn btn-outline-secondary">
                <i class="bi bi-caret-left-fill me-1"></i> Prev
            </button>
            <button @click="handleClicked('next')" class="btn btn-outline-secondary">
                <i class="bi bi-caret-right-fill me-1"></i> Next
            </button>
            <!-- Dropdown Menu -->
            <div class="dropdown ms-auto">
                <button class="btn btn-outline-dark dropdown-toggle" type="button" id="actionsDropdown"
                    data-bs-toggle="dropdown">
                    <i class="bi bi-gear me-1"></i> Actions
                </button>
                <ul class="dropdown-menu dropdown-menu-end">
                    <li><a @click.prevent="handleClicked('override')" class="dropdown-item" href="#"><i
                                class="bi bi-arrow-repeat me-2"></i> Admin Override</a>
                    </li>
                    <li><a @click.prevent="handleClicked('exclude')" class="dropdown-item" href="#"><i
                                class="bi bi-exclude me-2"></i> Exclude from RDCD</a>
                    </li>
                    <li><a @click.prevent="handleClicked('delete')" class="dropdown-item" href="#"><i
                                class="bi bi-trash me-2"></i> Delete Record</a>
                    </li>
                    <li>
                        <hr class="dropdown-divider">
                    </li>
                    <li><a @click.prevent="handleClicked('export')" class="dropdown-item" href="#"><i
                                class="bi bi-download me-2"></i> Export</a></li>

                </ul>
            </div>
        </div>

        <!-- Mobile View (stacked buttons + dropdown) -->
        <div class="d-flex d-md-none align-items-center gap-2 p-2 bg-light border-bottom">
            <button @click.prevent="handleClicked('new')" class="btn btn-primary btn-sm">
                <i class="bi bi-plus-circle"></i>
            </button>
            <button @click.prevent="handleClicked('save')" class="btn btn-secondary btn-sm">
                <i class="bi bi-floppy-fill"></i>
            </button>
            <button @click.prevent="handleClicked('load')" class="btn btn-secondary btn-sm">
                <i class="bi bi-download"></i>
            </button>
            <button @click.prevent="handleClicked('print')" class="btn btn-secondary btn-sm">
                <i class="bi bi-printer"></i>
            </button>


            <!-- Mobile Options Dropdown -->
            <div class="dropdown ms-auto">
                <button class="btn btn-outline-dark btn-sm dropdown-toggle" type="button" id="mobileActionsDropdown"
                    data-bs-toggle="dropdown">
                    <i class="bi bi-list"></i>
                </button>
                <ul class="dropdown-menu dropdown-menu-end">
                    <li><a @click.prevent="handleClicked('prev')" class="dropdown-item" href="#"><i
                                class="bi bi-caret-left-fill me-2"></i> Prev</a></li>
                    <li><a @click.prevent="handleClicked('next')" class="dropdown-item" href="#"><i
                                class="bi bi-caret-right-fill me-2"></i> Next</a></li>
                    <li><a @click.prevent="handleClicked('exclude')" class="dropdown-item" href="#"><i
                                class="bi bi-exclude me-2"></i> Exclude</a></li>
                    <li><a @click.prevent="handleClicked('delete')" class="dropdown-item" href="#"><i
                                class="bi bi-trash me-2"></i> Delete</a></li>
                    <li>
                        <hr class="dropdown-divider">
                    </li>
                    <li><a @click.prevent="handleClicked('override')" class="dropdown-item" href="#"><i
                                class="bi bi-arrow-repeat me-2"></i> Override</a></li>
                    <li><a @click.prevent="handleClicked('export')" class="dropdown-item" href="#"><i
                                class="bi bi-download me-2"></i> Export</a></li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script setup>
import { defineEmits } from 'vue';
const emits = defineEmits(['saveClicked', 'nextClicked', 'prevClicked', 'newClicked', 'loadClicked', 'printClicked',
    'overrideClicked', 'excludeClicked','deleteClicked','exportClicked'
]);

const handleClicked = (mode) => {
    switch (mode) {
        case 'save':
            emits('saveClicked')
            break;
        case 'next':
            emits('nextClicked')
            break;
        case 'prev':
            emits('prevClicked')
            break;
        case 'new':
            emits('newClicked')
            break;
        case 'load':
            emits('loadClicked')
            break;
        case 'print':
            emits('printClicked')
            break;
        case 'override':
            emits('overrideClicked')
            break;
        case 'exclude':
            emits('excludeClicked')
            break;
        case 'delete':
            emits('deleteClicked')
            break;
        case 'export':
            emits('exportClicked')
            break;
    }
}


</script>

<style scoped>
/* Optional custom styling */
.btn {
    white-space: nowrap;
}

.dropdown-menu {
    min-width: 200px;
}
</style>